export default __webpack_public_path__ + "static/media/pencil.c1deacd3.ogg";